import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Typography,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  Breadcrumbs,
  AppBar,
  Link,
  Stack,
  Button,
  TextField,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Navbar from "../../components/common/Navbar";
import CircularProgress from "@mui/material/CircularProgress";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { COUNTRY_API, LICENSE_API_05 } from "../../api/ApiModel";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import currencyFormat from "../../utils/common/CurrencyFormat";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
const CreateLicenseAddOns = () => {
  const location = useLocation();
  const { selectedRows } = location.state || { selectedRows: [] };
  const theme = useTheme();
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [data2, setData2] = useState(null);
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, EXPDATE, STS } = SYS_USER.USER_PARAM || {};
  const MODULECODE = 5;
  const gotToPage = () => {
    navigate("/LicenseAddOns");
  };
  const numbers = Array.from({ length: 1001 }, (_, index) => index);
  const [selectedNumbers, setSelectedNumbers] = useState({});

  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(COUNTRY_API, "get");
        setData2(result); // Update data with API response
        console.log("currency", result);
      } catch (err) {
        setError(err); // Handle error
        console.error("Error fetching currencies:", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(LICENSE_API_05, "get", {
          COMPCODE: COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });

        // Process the data: group by LICENSETYPENAME

        setData(result);
        console.log("Grouped Data:", result);
        const filtered = result.filter(
          (item) => item.MODULECODE === MODULECODE
        );
        setFilteredData(filtered);
        // Set the filtered data to state
        console.log("Filtered data:", filteredData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err);
      }
    };

    fetchData();
  }, []);

  const groupedData = (data || []).reduce((acc, item) => {
    const { LICENSETYPENAME, LICENSETYPECODE, MODULECODE, ARATE, MRATE } = item;

    // Ensure LICENSETYPENAME exists as a key
    if (!acc[LICENSETYPENAME]) {
      acc[LICENSETYPENAME] = [];
    }

    // Ensure MODULECODE exists under LICENSETYPENAME
    if (!acc[LICENSETYPENAME][MODULECODE]) {
      acc[LICENSETYPENAME][MODULECODE] = {
        LICENSETYPECODE, // Add LICENSETYPECODE
        ARATE,
        MRATE,
      };
    }

    return acc;
  }, {});

  const handleNumberChange = (event, value, licenseTypeCode) => {
    setSelectedNumbers((prev) => ({
      ...prev,
      [licenseTypeCode]: value, // Update state for the specific LICENSETYPECODE
    }));
  };

  const totalRate = selectedRows.reduce((sum, row) => {
    const rate = parseFloat(row.displayRate); // Ensure rate is a number
    return sum + (isNaN(rate) ? 0 : rate); // Add 0 if the rate is invalid (NaN)
  }, 0);

  const calculateTotalLicenseValue = () => {
    let total = 0;
    selectedRows.forEach((row) => {
      Object.keys(groupedData).forEach((licenseTypeName) => {
        Object.keys(groupedData[licenseTypeName]).forEach((moduleCode) => {
          if (parseInt(moduleCode, 10) === row.moduleCode) {
            const displayRate = row.displayRate;
            const selectedNumber =
              selectedNumbers[
                groupedData[licenseTypeName][moduleCode].LICENSETYPECODE
              ] || 0;
            total += displayRate * selectedNumber;
          }
        });
      });
    });
    return total;
  };

  // Example static value for addon
  const totalLicenseValue = calculateTotalLicenseValue(); // Dynamically calculated value for license

  // Calculate total package value (Addon + License)
  const totalPackageValue = totalRate + calculateTotalLicenseValue();

  // State for discount percentage and discounted total
  const [discount, setDiscount] = useState(0);
  const [discountedTotal, setDiscountedTotal] = useState(totalPackageValue);

  // Handle discount input change
  const handleDiscountChange = (event) => {
    const discountValue = parseFloat(event.target.value) || 0; // Default to 0 if invalid input
    setDiscount(discountValue);

    // Calculate discounted total
    const newTotal =
      totalPackageValue - (totalPackageValue * discountValue) / 100;
    setDiscountedTotal(newTotal);
  };

  const [formData, setFormData] = useState({
    companyName: "",
    email: "",
    hotline: "",
    countryCode: "",
    password: "",
    confirmPassword: "",
  });

  // State to handle form errors
  const [errors, setErrors] = useState({
    companyName: "",
    email: "",
    hotline: "",
    countryCode: "",
    password: "",
    confirmPassword: "",
  });

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validate the form fields
  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.companyName) {
      tempErrors.companyName = "Company Name is required";
      isValid = false;
    }

    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Valid Email is required";
      isValid = false;
    }

    if (!formData.hotline) {
      tempErrors.hotline = "Hotline is required";
      isValid = false;
    }

    if (!formData.countryCode) {
      tempErrors.countryCode = "Country is required";
      isValid = false;
    }

    if (!formData.password) {
      tempErrors.password = "Password is required";
      isValid = false;
    }

    if (formData.password !== formData.confirmPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // const handleRegister = async () => {
  //   if (validateForm()) {
  //     try {
  //       const responseData = await externalpostApi(LOCATION_API_02, payload);
  //       console.log('Registration successful:', response.data);
  //       // Handle successful response (e.g., redirect, show success message)
  //     } catch (error) {
  //       console.error('Error during registration:', error);
  //       // Handle error (e.g., show error message)
  //     }
  //   }
  // };

  return (
    <div>
      {/* <ul>
  {selectedRows.map((row, index) => (
    <li key={index}>
      <strong>Module Name:</strong> {row.moduleName}, 
      <strong> Addon Name:</strong> {row.addonName}, 
      <strong> Rate:</strong> {row.displayRate}, 
     
    </li>
  ))}
</ul> */}

      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Account</Link>
                <Link underline="none">License Addon</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box ml={12} mt={15} p={1}>
        <Box
          sx={{
            ml: 70,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" gutterBottom>
            {selectedRows.length > 0 &&
              `${selectedRows[0].subscriptionType} Subscription`}
          </Typography>
        </Box>
        <Grid container spacing={3} mt={-4}>
          {/* Box 1 */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                border: "1px solid #ddd",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: 1,
                maxHeight: "75vh",
                minHeight: "70vh",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Selected Addon Details
              </Typography>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 400 }}
                  aria-label="selected addons table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Module Name</TableCell>
                      <TableCell>Addon Name</TableCell>
                      <TableCell>Rate</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedRows.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.moduleName}</TableCell>
                        <TableCell>{row.addonName}</TableCell>
                        <TableCell>{row.displayRate}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>

          {/* Box 2 */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                border: "1px solid #ddd",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: 1,
                maxHeight: "70vh",
                minHeight: "70vh",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Available License Details
              </Typography>
              <div>
                {selectedRows.map((row, rowIndex) => {
                  const renderedLicenseTypes = new Set(); // Track rendered licenseTypeNames

                  return (
                    <div key={rowIndex}>
                      <div>
                        {Object.keys(groupedData).length > 0 ? (
                          Object.keys(groupedData).map((licenseTypeName) => {
                            if (renderedLicenseTypes.has(licenseTypeName)) {
                              return null; // Skip rendering if licenseTypeName is already displayed
                            }

                            renderedLicenseTypes.add(licenseTypeName); // Add licenseTypeName to the set

                            return (
                              <div key={licenseTypeName}>
                                {/* Filter MODULECODE */}
                                {Object.keys(groupedData[licenseTypeName]).map(
                                  (moduleCode) =>
                                    parseInt(moduleCode, 10) ===
                                    row.moduleCode ? ( // Check if moduleCode matches row.moduleCode
                                      <div key={moduleCode}>
                                        <Box
                                          sx={{
                                            display: "flex", // Use flexbox
                                            alignItems: "center", // Align items vertically
                                            justifyContent: "space-between", // Push items to opposite ends
                                            width: "100%", // Ensure it spans the container width
                                          }}
                                        >
                                          {/* Display licenseTypeName */}
                                          <h4>
                                            {licenseTypeName} (
                                            {
                                              groupedData[licenseTypeName][
                                                moduleCode
                                              ].LICENSETYPECODE
                                            }
                                            )
                                          </h4>

                                          {/* Autocomplete component */}
                                          <Autocomplete
                                            options={numbers}
                                            getOptionLabel={(option) =>
                                              option.toString()
                                            }
                                            onChange={(event, value) =>
                                              handleNumberChange(
                                                event,
                                                value,
                                                groupedData[licenseTypeName][
                                                  moduleCode
                                                ].LICENSETYPECODE
                                              )
                                            }
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label="Select a Number"
                                                variant="outlined"
                                              />
                                            )}
                                            size="small"
                                            value={
                                              selectedNumbers[
                                                groupedData[licenseTypeName][
                                                  moduleCode
                                                ].LICENSETYPECODE
                                              ] || 0
                                            }
                                            isOptionEqualToValue={(
                                              option,
                                              value
                                            ) => option === value}
                                            sx={{
                                              minWidth: 160,
                                            }}
                                            ListboxProps={{
                                              style: {
                                                maxHeight: 150,
                                                backgroundColor:
                                                  theme.palette.background
                                                    .paper,
                                              },
                                            }}
                                            noOptionsText={
                                              <div
                                                style={{
                                                  backgroundColor:
                                                    theme.palette.background
                                                      .paper,
                                                  padding: "8px",
                                                }}
                                              >
                                                No options
                                              </div>
                                            }
                                          />
                                        </Box>
                                      </div>
                                    ) : null
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <p>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "60vh",
                              }}
                            >
                              <CircularProgress color="primary" />
                            </Box>
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              <Divider sx={{ margin: "10px 0" }} />
              <Typography variant="h6" gutterBottom>
                Selected License Details
              </Typography>
              <div>
                {selectedRows.map((row, rowIndex) => (
                  <div key={rowIndex}>
                    {Object.keys(groupedData).length > 0 ? (
                      Object.keys(groupedData).map((licenseTypeName) => (
                        <div key={licenseTypeName}>
                          {/* Filter MODULECODE */}
                          {Object.keys(groupedData[licenseTypeName]).map(
                            (moduleCode) =>
                              parseInt(moduleCode, 10) === row.moduleCode ? ( // Check if moduleCode matches row.moduleCode
                                <div key={moduleCode}>
                                  <Box
                                    sx={{
                                      display: "flex",

                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* Display licenseTypeName and calculation */}
                                    <h4>
                                      {licenseTypeName} (
                                      {
                                        groupedData[licenseTypeName][moduleCode]
                                          .LICENSETYPECODE
                                      }
                                      ) {row.displayRate} *{" "}
                                      {selectedNumbers[
                                        groupedData[licenseTypeName][moduleCode]
                                          .LICENSETYPECODE
                                      ]
                                        ? selectedNumbers[
                                            groupedData[licenseTypeName][
                                              moduleCode
                                            ].LICENSETYPECODE
                                          ]
                                        : 0}
                                    </h4>

                                    {/* Calculate LicenseAmt */}
                                    <h4>
                                      {(() => {
                                        const LicenseAmt =
                                          row.displayRate *
                                          (selectedNumbers[
                                            groupedData[licenseTypeName][
                                              moduleCode
                                            ].LICENSETYPECODE
                                          ]
                                            ? selectedNumbers[
                                                groupedData[licenseTypeName][
                                                  moduleCode
                                                ].LICENSETYPECODE
                                              ]
                                            : 0);
                                        return currencyFormat(LicenseAmt);
                                      })()}
                                    </h4>

                                    {/* {(() => {
   const totalLicenseAmt = selectedRows.reduce((sum, row) => {
  
    return sum + LicenseAmt;
  }, 0);
  
  })()} */}

                                    {/* <Typography variant="h6" gutterBottom>
  Total License Amount: {currencyFormat(totalLicenseAmt)}
</Typography> */}
                                  </Box>
                                </div>
                              ) : null
                          )}
                        </div>
                      ))
                    ) : (
                      <p>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "60vh",
                          }}
                        >
                          <CircularProgress color="primary" />
                        </Box>
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <Divider sx={{ margin: "10px 0" }} />
              <Typography variant="h6" gutterBottom>
                Payment Details Summary
              </Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Total Addon Value</h4>
                <h4>{currencyFormat(totalRate)}</h4>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Total License Value</h4>
                <h4>{currencyFormat(calculateTotalLicenseValue())}</h4>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Total Package Value</h4>
                <h4>{currencyFormat(totalPackageValue)}</h4>
              </Box>

              {/* Discount Input Field */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Discount (%)</h4>
                <TextField
                  value={discount}
                  onChange={handleDiscountChange}
                  label="Discount (%)"
                  variant="outlined"
                  type="number"
                  size="small"
                  sx={{ width: "100px" }}
                />
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <h4>Discounted Total</h4>
                <h4>{currencyFormat(discountedTotal)}</h4>
              </Box>
            </Box>
          </Grid>

          {/* Box 3 */}
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                border: "1px solid #ddd",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: 1,
                maxHeight: "75vh",
                minHeight: "75vh",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Register Account
              </Typography>
              <Grid container mt={3}>
                <Grid item lg={12} md={12} xs={12} sm={12}>
                  <TextField
                    label={
                      <span>
                        Company Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="txtcompanyname"
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleInputChange}
                    error={Boolean(errors.companyName)}
                    helperText={errors.companyName}
                  />
                </Grid>

                <Grid item lg={12} md={12} xs={12} sm={12} mt={3}>
                  <TextField
                    label={
                      <span>
                        Email <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="txtemail"
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    error={Boolean(errors.email)}
                    helperText={errors.email}
                  />
                </Grid>

                <Grid item lg={12} md={12} xs={12} sm={12} mt={3}>
                  <TextField
                    label={
                      <span>
                        Hotline <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="txthotline"
                    size="small"
                    fullWidth
                    variant="outlined"
                    autoComplete="off"
                    name="hotline"
                    value={formData.hotline}
                    onChange={handleInputChange}
                    error={Boolean(errors.hotline)}
                    helperText={errors.hotline}
                  />
                </Grid>

                <Grid item lg={12} md={12} xs={12} sm={12} mt={3}>
                  <Autocomplete
                    options={data2 || []}
                    getOptionLabel={(option) => option.COUNTRY || ""}
                    value={formData.countryCode}
                    onChange={(event, newValue) =>
                      setFormData({
                        ...formData,
                        countryCode: newValue.COUNTRYCODE,
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            Country <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        variant="outlined"
                        size="small"
                        fullWidth
                        error={Boolean(errors.countryCode)}
                        helperText={errors.countryCode}
                      />
                    )}
                  />
                </Grid>

                <Grid item lg={12} md={12} xs={12} sm={12} mt={3}>
                  <TextField
                    label={
                      <span>
                        Password <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="txtpassword"
                    size="small"
                    fullWidth
                    variant="outlined"
                    type="password"
                    autoComplete="off"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    error={Boolean(errors.password)}
                    helperText={errors.password}
                  />
                </Grid>

                <Grid item lg={12} md={12} xs={12} sm={12} mt={3}>
                  <TextField
                    label={
                      <span>
                        Re-type Password <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    id="txtconfirmPassword"
                    size="small"
                    fullWidth
                    variant="outlined"
                    type="password"
                    autoComplete="off"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    error={Boolean(errors.confirmPassword)}
                    helperText={errors.confirmPassword}
                  />
                </Grid>

                <Stack
                  direction="row"
                  spacing={2}
                  m={1}
                  justifyContent="flex-end"
                  padding={1}
                >
                  <Button
                    variant="contained"
                    sx={styles.AI_button2}
                    id="btnconfirm"
                  >
                    Register
                  </Button>
                </Stack>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CreateLicenseAddOns;
